import React, { useState } from 'react';

export default function StepPayment({ tenant, service, booking, onDone }) {
  const [sent, setSent] = useState(false);

  const parseIds = (val, fallback) => {
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') { try { const p = JSON.parse(val); return Array.isArray(p) ? p : []; } catch { return []; } }
    return fallback ? [fallback] : [];
  };
  const cashappIds = parseIds(tenant.cashappIds, tenant.cashapp_id);
  const zelleIds   = parseIds(tenant.zelleIds,   tenant.zelle_id);
  const message    = tenant.depositMessage ||
    'Please send a deposit to secure your appointment. Once received, we will confirm your booking by call.';

  const price = service?.price_cents > 0
    ? `$${(service.price_cents / 100).toFixed(2)}`
    : null;

  return (
    <div className="w-payment">
      <div className="w-title">Complete Payment</div>

      {/* Deposit message */}
      <div className="w-payment-msg">
        {price && (
          <p className="w-payment-amount">
            Amount due: <strong>{price}</strong>
          </p>
        )}
        <p className="w-payment-note">{message}</p>
      </div>

      {/* CashApp IDs */}
      {cashappIds.length > 0 && (
        <div className="w-payment-section">
          <div className="w-payment-badge cashapp">
            <span className="w-payment-badge-label">CashApp</span>
          </div>
          {cashappIds.map((id, i) => (
            <div key={i} className="w-payment-id">
              <span className="w-payment-id-icon cashapp">$</span>
              <strong>{id}</strong>
            </div>
          ))}
        </div>
      )}

      {/* Zelle IDs */}
      {zelleIds.length > 0 && (
        <div className="w-payment-section">
          <div className="w-payment-badge zelle">
            <span className="w-payment-badge-label">Zelle</span>
          </div>
          {zelleIds.map((id, i) => (
            <div key={i} className="w-payment-id">
              <span className="w-payment-id-icon zelle">Z</span>
              <strong>{id}</strong>
            </div>
          ))}
        </div>
      )}

      {/* Confirmation button */}
      {!sent ? (
        <button className="w-btn w-btn-primary" style={{ marginTop: '1.25rem' }} onClick={() => setSent(true)}>
          I've Sent Payment ✓
        </button>
      ) : (
        <div className="w-payment-thanks">
          <div className="w-payment-thanks-icon">✓</div>
          <p>Thank you! We'll confirm your appointment by call once payment is received.</p>
          <button className="w-btn w-btn-secondary" style={{ marginTop: '0.75rem' }} onClick={() => onDone(booking)}>
            Done
          </button>
        </div>
      )}
    </div>
  );
}
